import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/hooks/useAuth";

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  return auth ? <Navigate to="/" /> : children;
};

export default ProtectedRoute;
